module.exports = __webpack_public_path__ + "static/media/About_ alcosmall.27f415d3.jpg";